import { DateTime } from 'luxon';

const ZONE = 'Asia/Karachi';

export function nowOffice() {
    return DateTime.now().setZone(ZONE);
}

export function utcStringToOffice(s) {
    return DateTime.fromISO(s, { zone: 'utc' }).setZone(ZONE);
}

export function formatTime(dt) {
    return dt.toFormat('h:mm a');
}

export function formatDate(dt) {
    return dt.toFormat('EEEE, d LLLL yyyy');
}

export function formatHourMinute(totalMinutes) {
    if (totalMinutes == null || isNaN(totalMinutes)) return '0h 0m';
    const h = Math.floor(totalMinutes / 60);
    const m = Math.round(totalMinutes - h * 60);
    return `${h}h ${m.toString().padStart(2, '0')}m`;
}

/**
 * Combine a date (YYYY-MM-DD) and time (HH:MM:SS) — both office-local — into
 * a Luxon DateTime in the office zone.
 */
export function combineOfficeDateTime(dateStr, timeStr) {
    return DateTime.fromISO(`${dateStr}T${timeStr}`, { zone: ZONE });
}
